import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';

function ContactInformationStack({ title, description, email, navigateTo }) {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '0.625rem',
        flexShrink: 0,
        maxWidth: '10rem',
        width: '100%',
      }}
    >
      <Typography
        variant="small_3"
        color={theme.palette.neutral.A400}
        fontWeight={700}
      >
        {title}
      </Typography>
      {(Array.isArray(description) ? description : [description]).map((item) => (
        <Typography
          key={item}
          variant="small_2"
          color={theme.palette.neutral.A400}
          fontWeight={500}
          href={navigateTo || null}
          rel={navigateTo ? 'noopener noreferrer' : null}
          target={navigateTo ? '_blank' : null}
          component={navigateTo ? 'a' : 'p'}
          sx={{
            ...(navigateTo && {
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline',
                cursor: 'pointer',
              },
            }),
          }}
        >
          {item}
        </Typography>
      ))}
      {email && (
        <Typography
          key={`email-${email}`}
          variant="small_2"
          color={theme.palette.neutral.A400}
          fontWeight={500}
          sx={{
            '&:hover': {
              textDecoration: 'underline',
              cursor: 'pointer',
            },
          }}
        >
          <a
            href={`mailto:${email}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: theme.palette.neutral.A400,
              textDecoration: 'none',
            }}
          >
            {email}
          </a>
        </Typography>
      )}
    </Stack>
  );
}

ContactInformationStack.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
  email: PropTypes.string.isRequired,
  navigateTo: PropTypes.string,
};

ContactInformationStack.defaultProps = {
  navigateTo: null,
};

export default ContactInformationStack;
